<template>
    <v-dialog
        v-model="open"
        max-width="850px"
        persistent
        :fullscreen="$vuetify.breakpoint.xsOnly"
    >
        <v-card class="background-2 round-card">
            <v-card-title class="pa-3">
                <p class="pl-2 pl-xl-3">Genera Documenti da Template</p>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text class="pa-0">
                <!-- Messaggio se non ci sono template -->
                <v-container v-if="docLists.length == 0" class="pa-8 text-center">
                    <v-icon size="64" color="grey lighten-1" class="mb-4">mdi-file-document-outline</v-icon>
                    <div class="text-h6 grey--text text--darken-1 mb-2">Nessun template disponibile</div>
                    <div class="text-body-2 grey--text mb-4">
                        Non è stato caricato ancora nessun template.<br>
                        Puoi farlo in <strong>Impostazioni {{ $trans(modelDef) }}</strong> nella sezione Stampa.
                    </div>
                    <v-btn text color="red" @click="closeDialog()">chiudi</v-btn>
                </v-container>

                <!-- Selezione template -->
                <v-container v-else class="pa-4" fluid>
                    <div class="d-flex align-center mb-3">
                        <v-icon left color="primary">mdi-file-multiple</v-icon>
                        <span class="text-subtitle-1 font-weight-medium">Seleziona un template</span>
                        <v-chip small class="ml-2" color="primary" outlined>
                            {{ docLists.length }} disponibili
                        </v-chip>
                    </div>

                    <v-slide-group
                        v-model="attachmentSelected"
                        class="py-2"
                        show-arrows
                        center-active
                    >
                        <v-slide-item
                            v-for="(docList, d) in docLists"
                            :key="d"
                            v-slot:default="{ active, toggle }"
                        >
                            <v-card
                                :elevation="active ? 8 : 2"
                                :class="['ma-3 template-card', { 'template-card--active': active }]"
                                height="180"
                                width="130"
                                @click="toggle"
                            >
                                <div class="template-card__preview" :style="docList.thumbnail ? {'background-image': 'url(data:image/jpeg;base64,'+ docList.thumbnail +')'} : {}">
                                    <v-icon v-if="!docList.thumbnail" size="48" color="grey lighten-1">mdi-file-word</v-icon>
                                    <div v-if="active" class="template-card__overlay">
                                        <v-icon color="amber" size="40">mdi-check-circle</v-icon>
                                    </div>
                                </div>
                                <v-card-text class="pa-2 text-center">
                                    <div class="text-caption font-weight-medium text-truncate">{{ docList.name }}</div>
                                </v-card-text>
                            </v-card>
                        </v-slide-item>
                    </v-slide-group>

                    <!-- Dettagli template selezionato -->
                    <v-expand-transition>
                        <v-card v-if="attachmentSelected != null" outlined class="mt-4">
                            <v-card-subtitle class="d-flex align-center py-3">
                                <v-icon left color="primary">mdi-information</v-icon>
                                <span class="text-subtitle-1 font-weight-medium">Dettagli e opzioni</span>
                            </v-card-subtitle>
                            <v-divider></v-divider>
                            <v-card-text class="pa-4">
                                <v-row align="center">
                                    <!-- Info template -->
                                    <v-col cols="12" md="6">
                                        <div class="d-flex align-center mb-3">
                                            <v-icon color="primary" class="mr-3">mdi-file-document</v-icon>
                                            <div>
                                                <div class="text-caption grey--text">Nome template</div>
                                                <div class="text-body-2 font-weight-medium">{{ docSelected.name }}</div>
                                            </div>
                                        </div>
                                        <div class="d-flex align-center">
                                            <v-avatar
                                                v-if="$store.getters.avatars[docSelected.creator_id]"
                                                :size="32"
                                                class="mr-3"
                                                :style="{'background-image': 'url(' + $store.getters.avatars[docSelected.creator_id] + ')', 'background-size': 'cover'}"
                                            ></v-avatar>
                                            <v-avatar
                                                v-else
                                                :size="32"
                                                :class="[$eventBusUtility.bgColor(docSelected.creator_id), 'mr-3']"
                                            >
                                                <span class="white--text text-body-2" v-if="docSelected.creator">{{ docSelected.creator.charAt(0) }}</span>
                                            </v-avatar>
                                            <div>
                                                <div class="text-caption grey--text">Creato da</div>
                                                <div class="text-body-2">{{ docSelected.creator }}</div>
                                            </div>
                                        </div>
                                    </v-col>

                                    <!-- Opzioni -->
                                    <v-col cols="12" md="6">
                                        <div class="d-flex flex-column align-center align-md-end">
                                            <v-btn-toggle
                                                v-model="ext"
                                                mandatory
                                                color="primary"
                                                class="mb-3"
                                            >
                                                <v-btn value="pdf" small>
                                                    <v-icon left small>mdi-file-pdf-box</v-icon>
                                                    PDF
                                                </v-btn>
                                                <v-btn value="docx" small>
                                                    <v-icon left small>mdi-file-word</v-icon>
                                                    DOCX
                                                </v-btn>
                                            </v-btn-toggle>

                                            <v-switch
                                                v-model="group"
                                                inset
                                                hide-details
                                                :disabled="ext == 'docx'"
                                                color="primary"
                                                class="mt-0"
                                            >
                                                <template v-slot:label>
                                                    <span class="text-body-2">Unisci in un documento</span>
                                                </template>
                                            </v-switch>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-expand-transition>
                </v-container>
            </v-card-text>

            <v-divider v-if="docLists.length > 0"></v-divider>
            <v-card-actions v-if="docLists.length > 0">
                <v-chip v-if="selectedIds && selectedIds.length > 0" small outlined color="grey" class="ml-2">
                    {{ selectedIds.length }} elementi selezionati
                </v-chip>
                <v-spacer></v-spacer>
                <v-btn text color="red" @click="closeDialog()">chiudi</v-btn>
                <v-btn
                    text
                    color="primary"
                    :disabled="attachmentSelected == null"
                    :loading="loading"
                    @click="convertDoc()"
                >
                    genera
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
	import Vue from 'vue'
	
	export default {
		name: 'parse-doc-dialog',
		props: {
            params: Object,
            selected: Array,
            selectedIds: Array,
            modelDef: String,
            open: Boolean
		},
		data() {
            return {
                show: false,
                attachmentSelected: null,
                loading: false,
                docLists: [],
                ext: 'pdf',
                group: false
			}
        },

        computed: {

            docSelected() {
                if(this.attachmentSelected != null && this.docLists[this.attachmentSelected] && this.docLists[this.attachmentSelected].name) {
                    return this.docLists[this.attachmentSelected]
                }
                return ''
            }
        },


		watch: {
			ext: {
				handler(newValue, oldValue) {
                    if(newValue == 'docx') {
                        this.group = false
                    }
				},
            },
        },

        created() {
            this.openDialog()
        },

        mounted() {
            this.$eventBusUtility.$on('openParseDoc', () => this.openDialog())
        },

        beforeDestroy() {
			this.$eventBusUtility.$off('openParseDoc')
		},

        methods: {
             openDialog() {
				this.axios.post('attachmentslists/', {attachable_type: this.params.model, id: 0, key: 'name', value: 'id'}).then(response => {
					this.docLists = response.data.attachments
					this.show = true

				}, response => {
					// error callback
				})
            },

            convertDoc() {

                this.loading = true
                this.axios.post('convert-docx/', 
                    {
                        class: this.modelDef,
                        selected: this.selectedIds,
                        attachment_id: this.docSelected.id,
                        group: this.group,
                        ext: this.ext,
                    }).then(response => {

                    this.closeDialog()
                    this.loading = false
                }, response => {

                })

			},


			closeDialog() {
                this.attachmentSelected = null
				this.$emit('close')
			},
        }
	}
</script>

<style scoped>
.template-card {
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    border-radius: 12px !important;
    border: 2px solid rgba(128, 128, 128, 0.3) !important;
}

.template-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3) !important;
}

.template-card--active {
    border: 3px solid #1976d2 !important;
    box-shadow: 0 0 16px rgba(25, 118, 210, 0.6) !important;
}

.template-card__preview {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, rgba(128, 128, 128, 0.2) 0%, rgba(128, 128, 128, 0.08) 100%);
    background-size: cover;
    background-position: center;
    position: relative;
    border-radius: 10px 10px 0 0;
}

.template-card__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(25, 118, 210, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px 10px 0 0;
}

::v-deep .v-slide-group__content {
    padding: 8px 0;
}
</style>
